import React, { useState } from "react";
import DesktopResearchImage from "assets/breakfast-event/png-jpg/desktop-research.png";
import CheckImage from "assets/desktop-research/svgs/check.svg";
import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import AccessReportModal from "./AccessReportModal";
import { useTranslation } from "react-i18next";
import { report_reasonEn, report_reasonFr } from "./utils";

const LsatSection = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("event");
  const language = localStorage.getItem("selectedLanguage");

  const report_reason = language?.includes("fr")
    ? report_reasonFr
    : report_reasonEn;

  const handleRedirect = () => {
    window.open(
      "https://drive.google.com/file/d/1gJcShzSSU6L-Ohzty-Lcxp_PEborDImq/view?usp=sharing",
      "_blank",
    );
  };
  return (
    <div className="xl:h-[355px] flex justify-center items-center mt-20 mb-[10rem]">
      <div className="w-[90%] xl:w-[92%] flex justify-center items-center flex-col">
        <div className="flex items-center flex-col md:flex-row">
          <div className="bg-[#141B3D] h-[317px] p-5 md:w-[45%] xl:w-[40%] space-y-10">
            <img
              src={DesktopResearchImage}
              alt="DesktopResearchImage"
              className="w-[250px] h-[24px] md:w-[315px] md:h-[33px]"
            />
            <h3 className="text-white text-[32px] font-euclidSemibold md:w-[80%] xl:w-[70%]">
              {t("desktopResearch.lastSection.title")}
            </h3>
          </div>
          <div className="md:w-[55%] xl:w-[60%] bg-[#95D2AE] xl:h-[355px] px-[1rem] md:px-[2rem] xl:px-[3rem] py-[1.5rem] xl:py-[2.5rem] space-y-5 xl:space-y-8">
            <div className="space-y-1">
              <p className="text-[#1C295A] text-base font-euclidMedium">
                {t("desktopResearch.lastSection.desc")}
              </p>

              <div className="space-y-4">
                {report_reason.map((option, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <img
                      src={CheckImage}
                      alt="CheckImage"
                      className="w-[25px] h-[25px] mt-1"
                    />
                    <p className="text-lg text-[#1C295A] font-euclidRegular">
                      {option}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div onClick={handleRedirect}>
              <div className="flex items-center">
                <button className="bg-[#202D66] font-euclid text-white text-base xl:text-base font-euclidSemibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none">
                  {t("desktopResearch.cta2")}
                </button>
                <button className="bg-[#AFF7CD] text-white text-base font-euclidSemibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                  <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                </button>
              </div>
            </div>
          </div>
          <AccessReportModal isOpen={open} onClose={() => setOpen(false)} />
        </div>
      </div>
    </div>
  );
};

export default LsatSection;
